// extracted by mini-css-extract-plugin
export default {"top":"ToTop_top__ogB8x"};